/* @flow */

import * as React from 'react'
import styled from 'styled-components'

import WebshopCenteredContentContainer from '../../WebshopCenteredContentContainer'
import { WidgetContainer } from '../shared'

const WebshopCenteredContentWidget = ({ gridItem, ...rest }) => {
  return (
    <WebshopCenteredContentContainer>
      {gridItem.children.map(childGridItem => {
        const GridItemComponent = childGridItem.component

        if (!GridItemComponent) {
          return null
        }

        return <GridItemComponent gridItem={childGridItem} {...rest} />
      })}
    </WebshopCenteredContentContainer>
  )
}

export default WebshopCenteredContentWidget
